import { render, staticRenderFns } from "./FooterToolBar.vue?vue&type=template&id=3af6ac89&scoped=true&"
import script from "./FooterToolBar.vue?vue&type=script&lang=js&"
export * from "./FooterToolBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af6ac89",
  null
  
)

export default component.exports